/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,prefer-destructuring */

import { EVENTS } from '../../../../app/constants/events';
import { DESIGNER_EVENTS } from '../../../../app/constants/designer_events';
import { setComponent, setComponentValidity } from '../../../../app/package-designer/store/component.actions';
import { setSchemas } from '../../../../app/common/validators/store/validators.actions';
import { areComponentFieldsValid } from '../../../../app/package-designer/helpers/components.helpers';

xplenty.controller('ComponentEditorController', [
  '$scope',
  '$rootScope',
  '$timeout',
  'modalService',
  'ComponentEditorListeners',
  'ngrxStoreService',
  'Rollbar',
  function ($scope, $rootScope, $timeout, modalService, ComponentEditorListeners, ngrxStoreService, Rollbar) {
    // attaching scope to controller instance to expose it to requiring directives underneath
    this.$scope = $scope;

    $scope.component = _.cloneDeep($scope._default.getFormData());
    $scope._component = _.cloneDeep(_.clone($scope.component));
    if (Rollbar.Rollbar) {
      Rollbar.Rollbar.captureEvent($scope.component, 'info');
    }

    ngrxStoreService.dispatch(setComponent({ component: JSON.parse(JSON.stringify($scope.component)) }));

    $scope.parentSchemas = $scope._default.getParentComponentsSchemas();

    $scope.saveDisabled = false;
    $scope.componentNameValid = true;

    $scope.$on(EVENTS.SCHEMA_IMPORTER_CHANGED, function (event, _selectedFields) {
      $scope._selectedFields = _selectedFields;
    });

    $scope.save = function (fields, fieldsName) {
      if ($scope._selectedFields) {
        $scope.component.schema = { ...$scope.component.schema, fields: _.clone($scope._selectedFields) };
      }

      if (fields) {
        $scope.component[fieldsName] = fields;
      }

      $scope._default.setFormData($scope.component);

      $scope.component = $scope._default.getFormData();
      $scope._component = $scope._default.getFormData();
    };

    const deregisterRootScopeListener = $rootScope.$on(
      EVENTS.DESIGNER_COMPONENT_FIELDS_UPDATE,
      (event, { fields, fieldsName }) => $scope.save(fields, fieldsName),
    );

    $scope.closeModal = function () {
      modalService.hideModal();

      _.each(ComponentEditorListeners.onCancelListeners, function (listenerFn) {
        listenerFn();
      });
    };

    $scope.saveAndCloseModal = function () {
      const preventSave = $scope.notifyOnSave();
      if (Rollbar.Rollbar) {
        Rollbar.Rollbar.captureEvent($scope.component, 'info');
      }

      if (!preventSave) {
        $scope.notifyOnSaveSuccess();
        $timeout(function () {
          $scope.save();
          modalService.hideModal();
        });
      }
    };

    $scope.notifyOnSave = function () {
      // notify all listeners and catch if any returns false if save should be prevented. If nothing is returned save is not prevented
      let preventSave;
      let rollbarEventData;
      _.each(ComponentEditorListeners.onSaveListeners, function (listenerFn) {
        const listenerFnData = listenerFn() || {};
        if (!listenerFnData.isValid) {
          rollbarEventData = listenerFnData;
        }
        const cbPassed = listenerFnData.isValid;
        if (preventSave !== true) preventSave = cbPassed === false;
      });

      if (preventSave) {
        Rollbar.warning('Save button is not working.', rollbarEventData);
      }
      return false;
    };

    $scope.notifyOnSaveSuccess = function () {
      _.each(ComponentEditorListeners.onSaveSuccessListeners, function (listenerFn) {
        listenerFn();
      });
    };

    $scope.createStep = function (title, activeTitle, directive) {
      return {
        title,
        activeTitle,
        directive,
        tags: [],
        active: false,
        valid: false,
        lock: false,
        disable: false,
        loading: false,
      };
    };

    $scope.$on(EVENTS.DESIGNER_COMPONENT_SAVE_DISABLE, function (event, saveDisabled) {
      const areComponentFieldsValidFlag = areComponentFieldsValid($scope.component);
      $scope.saveDisabled = saveDisabled || !areComponentFieldsValidFlag;
      ngrxStoreService.dispatch(setComponentValidity({ isComponentFormValid: !saveDisabled }));
    });

    $scope.$watch(
      'component',
      function (component) {
        const isEqual = _.isEqual(component, $scope._default.getFormData());
      },
      true,
    );

    $scope.$on(EVENTS.DESIGNER_COMPONENT_NAME_VALID, function (event, valid) {
      $scope.componentNameValid = valid;
    });

    $scope.$on(DESIGNER_EVENTS.COMPONENT_RETURN_PARENT_SCHEMA, function (event, schemas) {
      $scope.schemas = schemas;

      if (!$scope.component.schema && schemas.length === 1) {
        $scope.component.schema = schemas[0];
      }

      if (schemas.length > 0) $scope.schemaFields = schemas[0].fields;
      if (schemas.length > 1) $scope.schemaFields2 = schemas[1].fields;
      ngrxStoreService.dispatch(setSchemas({ schemas: $scope.schemas }));
    });

    $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_GET_PARENT_SCHEMA, $scope.component.id);

    $rootScope.getBaseEditorSchemas = function () {
      return $scope.schemas;
    };

    $scope.$on('$destroy', function () {
      deregisterRootScopeListener();
    });
  },
]);
